export default __webpack_public_path__ + "static/media/community-launchpad-icon.16a518d2.png";